// angular imports
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { CCMessageBoxIcon, IconConstants, MessageBoxComponent, Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

@Component({
    selector: 'app-workflow-cam-deny',
    templateUrl: './workflow-cam-deny.component.html',
    styleUrls: ['./workflow-cam-deny.component.scss']
})
export class WorkflowCamDenyComponent implements OnInit {
    @ViewChild('denyWorkflowPopup', { static: false }) denyWorkflowPopup: DxPopupComponent;
    @ViewChild('denyWorkflowMessageBox', { static: false }) denyWorkflowMessageBox: MessageBoxComponent;

    @Output() onClose = new EventEmitter<void>();
    @Output() onDenyReasonChange = new EventEmitter<string>();

    denyWorkflowReason: string;
    visible = false;
    denyWorkflowReasonMaxLength = 500;
    iconCancel = IconConstants.CANCEL;
    iconCheck = IconConstants.CHECK;

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onDenyWorkflowPopUpShown(): void {
        this.denyWorkflowPopup.instance.repaint();
    }

    onDenyWorkflowPopUpClose(): void {
        this.closeDenyReasonPopup();
    }

    onReasonValueChanged(e: any): void {
        this.denyWorkflowReason = e.event.target.value;
    }

    getCharacterCount(): number {
        return Utils.notNullOrEmpty(this.denyWorkflowReason) ? this.denyWorkflowReason.length : 0;
    }

    onDenyConfirmWorkflow(): void {
        if (this.denyWorkflowReason && this.denyWorkflowReason.toString().length > 2) {
            this.visible = false;
            this.onDenyReasonChange.emit(this.denyWorkflowReason);
            this.closeDenyReasonPopup();
        } else {
            this.denyWorkflowMessageBox.showWithFixedWidthAndIcon(
                CCMessageBoxIcon.info,
                'Information',
                'Please provide a reason to deny this Invoice.',
                320
            );
        }
    }

    private closeDenyReasonPopup(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
